"use client";
import { useLocalization, useRouter } from '@akinon/next/hooks';
import { Button, Icon } from '@theme/components';
import { ROUTES } from '@theme/routes';
import { pcSearch } from '@theme/utils/personaclick';
import clsx from 'clsx';
import { Ref, useCallback, useState } from "react";

export const SearchForm = ({
  className,
  inputRef
}: {
  className?: string;
  inputRef?: Ref<HTMLInputElement>;
}) => {
  const [searchText, setSearchText] = useState('');
  const router = useRouter();
  const { t } = useLocalization();

  const submitSearch = useCallback(
    (value?: string) => {
      const text = (value ?? searchText).trim();
      if (!text) return;

      router.push(`${ROUTES.SEARCH}/?search_text=${text}`);
      pcSearch(text);
    },
    [router, searchText]
  );

  return (
    <div className={clsx("flex items-center bg-white rounded-[5rem] px-2 h-10", className)}>
      <Icon name="search" size={32} className="mr-2" />
      <input
        ref={inputRef}
        className="text-base font-normal placeholder:text-[#A5A5A5] text-primary-black grow outline-none ring-0 focus:outline-none focus:ring-0 personaclick-instant-search"
        placeholder={t('common.search.placeholder')}
        onChange={(e) => setSearchText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && searchText.trim() !== '') {
            router.push(`${ROUTES.SEARCH}/?search_text=${searchText}`);
            pcSearch(searchText);
          }
        }}
      />

      <Button
        type="button"
        onClick={() => submitSearch()}
        disabled={searchText.trim() === ""}
        className={clsx(
          "block lg:hidden bg-[#2E2E2E] text-white capitalize ml-2 px-5 h-8 text-sm font-normal leading-[10px]",
          "disabled:opacity-50 disabled:cursor-not-allowed"
        )}
      >
        {t('common.search.placeholder')}
      </Button>
    </div>
  );
};
